export default [
  {
    path: '/profile',
    name: 'r_profile',
    meta: {
      middlewares: {
        auth: null,
        permission: ['USER_PROFILE', 'read'],
      },
    },
    component: () => import('../../components/profile/Profile'),
    children: [
      {
        path: 'language',
        name: 'r_profile-language',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/global/LanguageSelection'),
      },
      {
        path: 'timezone',
        name: 'r_profile-timezone',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/global/TimezoneSelection'),
      },
      {
        path: 'change-password',
        name: 'r_profile-change-password',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        component: () => import('../../components/change-password/ChangePassword'),
      },
      {
        path: 'groups',
        name: 'r_groups',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        component: () => import('../../components/groups/Groups'),
      },
      {
        path: 'roles',
        name: 'r_roles',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        component: () => import('../../components/roles/Roles'),
      },
      {
        path: 'country',
        name: 'r_profile-country',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: {
          backLinkName: 'r_profile',
        },
        component: () => import('../../components/global/CountrySelection'),
      },
      {
        path: 'push-notifications',
        name: 'r_profile-push-notifications',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        component: () => import('../../components/profile/UserNotifications'),
      },
      {
        path: 'sync-with-outlook',
        name: 'r_profile-sync-with-outlook',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/profile/SyncWithOutlook'),
      },
      {
        path: 'sync-with-google',
        name: 'r_profile-sync-with-google',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/profile/GoogleCalendarAuth'),
      },
      {
        path: 'photo',
        name: 'r_profile-photo',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/profile-photo/ProfilePhoto'),
      },
      {
        path: 'assigned-resources',
        name: 'r_profile-assigned-resources',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/profile/AssignedResources'),
        children: [
          {
            path: 'edit/:assignedResourceId',
            name: 'r_profile-assigned-resources-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: ['USER_PROFILE', 'read'],
              },
            },
            props: { backLinkName: 'r_profile-assigned-resources' },
            component: () => import('../../components/profile/EditAssignedResource'),
            children: [
              {
                path: 'add-break',
                name: 'r_profile-add-break',
                meta: {
                  middlewares: {
                    auth: null,
                    permission: ['USER_PROFILE', 'read'],
                  },
                },
                props: { backLinkName: 'r_profile-assigned-resources-edit' },
                component: () => import('../../components/profile/AssignedResourceBreak'),
              },
              {
                path: ':breakId',
                name: 'r_profile-edit-break',
                meta: {
                  middlewares: {
                    auth: null,
                    permission: ['USER_PROFILE', 'read'],
                  },
                },
                props: {
                  backLinkName: 'r_profile-assigned-resources-edit',
                  actionType: 'edit',
                },
                component: () => import('../../components/profile/AssignedResourceBreak'),
              },
            ],
          },
        ],
      },
      {
        path: 'my-delegates',
        name: 'r_profile-my-delegates',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/profile/MyDelegates'),
        children: [
          {
            path: 'add',
            name: 'r_profile-my-delegates-add',
            meta: {
              middlewares: {
                auth: null,
                permission: ['USER_PROFILE', 'read'],
              },
            },
            props: { backLinkName: 'r_profile-my-delegates' },
            component: () => import('../../components/profile/MyDelegatesAdd'),
            children: [
              {
                path: 'permission/:userId',
                name: 'r_profile-my-delegates-add-permission',
                meta: {
                  middlewares: {
                    auth: null,
                    permission: ['USER_PROFILE', 'read'],
                  },
                },
                props: { backLinkName: 'r_profile-my-delegates-add' },
                component: () => import('../../components/profile/MyDelegatesAddPermission'),
              },
            ],
          },
          {
            path: 'edit/:delegationId',
            name: 'r_profile-my-delegates-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: ['USER_PROFILE', 'read'],
              },
            },
            props: { backLinkName: 'r_profile-my-delegates' },
            component: () => import('../../components/profile/MyDelegatesUpdate'),
          },
        ],
      },
      {
        path: 'delegated-by',
        name: 'r_profile-delegated-by',
        meta: {
          middlewares: {
            auth: null,
            permission: ['USER_PROFILE', 'read'],
          },
        },
        props: { backLinkName: 'r_profile' },
        component: () => import('../../components/profile/DelegatedBy'),
      },
    ],
  },
];
